export default __webpack_public_path__ + "static/N0100-7777dbf6ddd24c0030d67192529ba66c.png";